import 'core-js'

/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6'

/* Services
 ---------------------------------------------------------- */

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import NewsSlider from './modules/_news-slider'
import ModalBox from './modules/_modal-box'
import LazyLoad from './modules/_lazy-load'
import CasesSlider from './modules/_cases-slider'
import Counter from './modules/_counter'
import StepsSlider from './modules/_steps-slider'
import ProductsSlider from './modules/_products-slider'
import FloatingLabels from './modules/_floating-labels'
import Accordion from './modules/_accordion'
import Tabs from './modules/_tabs'
import ScrollDown from './modules/_scroll-down'
import Filters from './modules/_filters'
import LanguageModal from './modules/_language-modal'
import MapTooltip from './modules/_map-tooltip'
import Sliders from './modules/_sliders'
import NavigationSearch from './modules/_navigation-search'
import ImageSlider from './modules/_image-slider'

/* Vendor
 ---------------------------------------------------------- */

/* Setup
 ---------------------------------------------------------- */
const app = window.app = new Application(window.options || {})

/* Register modules
 ---------------------------------------------------------- */
app.use(Navigation)
app.use(ObjectFit)
app.use(Print)
app.use(NewsSlider)
app.use(CasesSlider)
app.use(ModalBox)
app.use(LazyLoad)
app.use(Counter)
app.use(StepsSlider)
app.use(ProductsSlider)
app.use(FloatingLabels)
app.use(Accordion)
app.use(Tabs)
app.use(ScrollDown)
app.use(Filters)
app.use(LanguageModal)
app.use(Sliders)
app.use(MapTooltip)
app.use(NavigationSearch)
app.use(ImageSlider)

require('./app')
